import React, { useEffect, useState } from 'react';
import Button from '../../../components/button/Button';
import title from '../../../assets/webp-images/challenge-ob-name-title.png';
import '../../signup-form/LandingPage.css';
import { Mixpanel } from '../../../analytics/Mixpanel';

type Props = {
	onContinue: () => void;
	userName: string;
	setUserName: (value: string) => void;
};

const ChallengeObName: React.FC<Props> = ({
	onContinue,
	userName,
	setUserName,
}) => {
	const [isInputFocused, setIsInputFocused] = useState(false);

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setUserName(e.target.value);
	};

	const onContinueTap = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'Your name?',
			name: userName,
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
		onContinue();
	};

	useEffect(() => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: 'Your name?',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
	}, []);

	return (
		<div style={{ display: 'flex', flexDirection: 'column', height: '70%' }}>
			<img src={title} style={{ width: '100%', marginTop: '16px' }} alt='' />
			<div
				style={{
					flex: '1',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '0 16px',
				}}>
				<input
					type='text'
					value={userName}
					placeholder={'Enter your full name'}
					onChange={handleInputChange}
					className={`${userName ? 'input-value' : 'input-placeholder'} ${
						isInputFocused ? 'input-focus' : ''
					}`}
					style={{
						fontSize: '24px',
						lineHeight: '32px',
						width: '100%',
						padding: '8px',
						borderLeft: 'none',
						borderRight: 'none',
						borderTop: 'none',
						textAlign: 'center',
						cursor: 'pointer',
					}}
					onFocus={() => setIsInputFocused(true)}
					onBlur={() => setIsInputFocused(false)}
				/>
			</div>
			<Button
				isSticky={true}
				disabled={userName.length < 3}
				style={{
					alignSelf: 'center',
					marginBottom: '24px',
					width: 'calc(100% - 56px)',
					background:
						userName.length < 3
							? '#dddddd'
							: 'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
				}}
				onClick={onContinueTap}
				label={'Continue'}></Button>
		</div>
	);
};

export default ChallengeObName;
